document.addEventListener("DOMContentLoaded", function () {
  var rainShedBanner = document.getElementById(
    "section-id-sections--18243959423196__announcement-bar"
  );

  if (rainShedBanner) {
    var isRainShedDomain = window.location.hostname.indexOf("therainshed.com") !== -1;
    var isRainShedReferrer = document.referrer.toLowerCase().indexOf("therainshed.com") !== -1;
    var isTaggedSession = sessionStorage.getItem("isRainShedCustomer") === "true";

    rainShedBanner.style.setProperty("display", "none", "important");

    if (isRainShedDomain || isRainShedReferrer || isTaggedSession) {
      sessionStorage.setItem("isRainShedCustomer", "true");

      rainShedBanner.style.setProperty("--announcement-background", "#E06D53", "important");
      rainShedBanner.style.setProperty("--announcement-text", "#FFFFFF", "important");
      rainShedBanner.style.setProperty("display", "block", "important");
    }
  }
});